// eslint complains about this not being the default because there's only one constant defined here, assuming this file will grow so diaabling
export const ZERO_DAY_FLEXIBILITY_VALUE = 0;
export const YEAR_FLEXIBILITY_VALUE = -1;
export const MONTH_FLEXIBILITY_VALUE = -2;

export const flexibilityItems = [
  {
    label: '+/- 0 Days',
    value: ZERO_DAY_FLEXIBILITY_VALUE,
  },
  {
    label: '+/- 1 Day',
    value: 1,
  },
  {
    label: '+/- 3 Days',
    value: 3,
  },
  {
    label: '+/- 5 Days',
    value: 5,
  },
  {
    label: 'Month',
    value: MONTH_FLEXIBILITY_VALUE,
  },
];



/** WEBPACK FOOTER **
 ** ./src/constants/searchUnit.js
 **/